export class Integration {
    integrationId: string
    companyId: string
    userId: string
    schedulerId: string
    provider: string
    providerToken: string
    providerSchedulerId: string
    externalLabel: string
    createdAt: Date
    updatedAt: Date
    lastSync?: Date
    log?: string
    status: number
}
